
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AirspaceAttributes } from '../../../typings/features/airspace-attributes';
import { AbstractDetailComponent } from '../abstract-detail.component';

@Component({
  selector: 'jmkw-airspace-detail',
  standalone: true,
  imports: [],
  templateUrl: './airspace-detail.component.html',
  styleUrls: ['./airspace-detail.component.scss', '../nav-widgets.shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AirspaceDetailComponent extends AbstractDetailComponent<AirspaceAttributes> {
  @Input() attributes!: AirspaceAttributes;
}
